import React from "react";
import PropTypes from "prop-types";

import { Checkbox } from "material-ui";
import { withStyles } from "material-ui/styles";

import CInput from "uis/CInput";

const styles = {
  paperDesc: {
    color: "#9699a2",
    fontSize: "1.1em"
  },
  checkbox: {
    height: "100%",
    marginTop: 1
  },
  bgGray: {
    backgroundColor: "lightgray"
  }
};

const FreeCommentArea = props => {
  // state
  const {
    classes,
    required,
    label,
    freeCommentDescription,
    freeCommentCheck,
    isOpened
  } = props;

  // action
  const { onChangeTextField, onChangeCheckBox } = props;

  return (
    <div style={{ display: "flex" }}>
      <span
        className={classes.paperDesc}
        style={{ display: "inline-block", width: 160 }}
      >
        {label}
        {required && "*"}
      </span>

      <CInput
        style={{ marginBottom: 10, width: 750 }}
        classes={{
          input: freeCommentCheck ? "" : classes.bgGray
        }}
        inputProps={{ maxLength: 250 }}
        disabled={!freeCommentCheck || isOpened}
        value={freeCommentDescription}
        onChange={e => onChangeTextField(e.target.value)}
      />

      {!required && (
        <Checkbox
          checked={freeCommentCheck}
          className={classes.checkbox}
          disabled={isOpened}
          onChange={(e, value) => onChangeCheckBox(value)}
        />
      )}
    </div>
  );
};

FreeCommentArea.defaultProps = {
  required: false,
  freeCommentCheck: true,
  onChangeCheckBox: null
};

FreeCommentArea.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpened: PropTypes.bool.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string.isRequired,
  freeCommentDescription: PropTypes.string.isRequired,
  freeCommentCheck: PropTypes.bool,
  onChangeTextField: PropTypes.func.isRequired,
  onChangeCheckBox: PropTypes.func
};

export default withStyles(styles)(FreeCommentArea);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/BaseInfo/FreeCommentArea.jsx